var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mc-header',{attrs:{"system-type":_vm.systemTpe,"background-color":_vm.backgroundColorStyle},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('McTime'),_vm._v(" "),_c('McLang',{attrs:{"lx-config":_vm.lxConfig}}),_vm._v(" "),_c('AccountMenu')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }